// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"index_3kBYo","linksWrapper":"index_-ONZn","passwordLabelWrapper":"index_3D_bu","security":"index_2G4FI"};